import React from 'react';
import ImageComponent from 'atoms/Image';
import { ButtonComp } from 'atoms/Buttons';
import { useHistory } from 'react-router-dom';
const ImgComponent = ({ scrollRotation, isPositionRight, data, isSocialImpactPage }) => {
  const { ctaButton, description, headline, image, imageText } = data[0]?.fields || {};
  const { buttonText = '' } = ctaButton?.fields || {};
  const { file } = image?.fields || {};

  const history = useHistory();

  return (
    <div className='block-container'>
      <div className='sub-container'>
        <div className='two-column-section'>
          <div
            className={`image-section 
                         ${scrollRotation && (isPositionRight ? 'position-right' : 'position-left')} 
                         ${isPositionRight && 'image-right'} 
                         ${isSocialImpactPage && 'img-order'}
                        `}
          >
            {imageText && <span className='image-text'>{imageText}</span>}
            <ImageComponent srcFile={file?.url} />
          </div>
          <div
            className={`desc-section ${scrollRotation ? 'pr' : 'pl'} ${isPositionRight ? 'right-desc' : 'left-desc'}`}
          >
            {headline && <h2 className='heading-section'>{headline}</h2>}
            <div className='short-desc-section'>
              {description?.content.map((desc, index) => {
                const { content } = desc;
                return (
                  <>
                    {(!isSocialImpactPage || description?.content?.length - 1 !== index) && (
                      <span className={`p2 ${index !== 0 && 'mtop'}`}>{content[0]?.value}</span>
                    )}
                    {description?.content?.length - 1 === index && ctaButton && (
                      <div className='learn-more-container mtop'>
                        <span className='learn-more-text'>{content[0]?.value}</span>
                        <span className='find-more-btn'>
                          <ButtonComp
                            className='button transparent-btn black-border'
                            onClick={() =>
                              ctaButton?.fields?.url
                                ? history.push(ctaButton?.fields?.url)
                                : window.open(ctaButton?.fields?.externalUrl, '_blank')
                            }
                            data-testid='find-out-more'
                          >
                            {buttonText}
                          </ButtonComp>
                        </span>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImgComponent;
